__turbopack_context__.v({
  "blink": "Quote-module-scss-module__sVXhsq__blink",
  "quote": "Quote-module-scss-module__sVXhsq__quote",
});
